// extracted by mini-css-extract-plugin
module.exports = {"pill":"Tab_pill__Dh98J"};